module.exports = "<div class=\"row form-horizontal\" style=\"display: flex; justify-content: center; align-items: center; height: 275px;\">\n    <p style=\"font-size: 20px;\"><a ng-click=\"vm.openCompleteAccountModal()\" style=\"cursor: pointer;\">Launch plan\n            enrollment</a> to complete your\n        migration</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/pages/complete-migration/plan-enrollment.html
// module id = 564
// module chunks = 3